import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'

import { User } from '../../../../../../entities-next/user'

export function successfulDeleteAlertAction(user: User) {
  return showFlashNotice({
    message: `User with id ${user.id} deleted`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function failedDeleteAlertAction(user: User) {
  return showFlashNotice({
    message: `User with id ${user.id} could not be deleted`,
    autoHide: true,
    variant: FlashNoticeVariant.error,
  })
}
